import { createFileRoute } from "@tanstack/react-router";

import { CloudSettingsPanel } from "../components/settings/CloudSettingsPanel";

export const Route = createFileRoute("/settings/cloud")({
  component: CloudSettingsPanel,
});
